import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';

interface AppConnectionStatusTagProps {
	installed: boolean;
}

export const AppConnectionStatusTag: React.FC<AppConnectionStatusTagProps> = ({ installed }) =>
	<Tag color={ installed ? 'blue' : 'orange' }>
		{ installed ? COPY_SPECIFIC.INSTALLED : COPY_SPECIFIC.CONNECTED }
	</Tag>;

